"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMaterialDataEditViewModel = instanceOfMaterialDataEditViewModel;
exports.MaterialDataEditViewModelFromJSON = MaterialDataEditViewModelFromJSON;
exports.MaterialDataEditViewModelFromJSONTyped = MaterialDataEditViewModelFromJSONTyped;
exports.MaterialDataEditViewModelToJSON = MaterialDataEditViewModelToJSON;
exports.MaterialDataEditViewModelToJSONTyped = MaterialDataEditViewModelToJSONTyped;
/**
 * Check if a given object implements the MaterialDataEditViewModel interface.
 */
function instanceOfMaterialDataEditViewModel(value) {
    return true;
}
function MaterialDataEditViewModelFromJSON(json) {
    return MaterialDataEditViewModelFromJSONTyped(json, false);
}
function MaterialDataEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'mdMaterialNo': json['mdMaterialNo'] == null ? undefined : json['mdMaterialNo'],
        'mdOrgId': json['mdOrgId'] == null ? undefined : json['mdOrgId'],
        'oName': json['oName'] == null ? undefined : json['oName'],
        'mdBackstageKey': json['mdBackstageKey'] == null ? undefined : json['mdBackstageKey'],
        'mdMaterialId': json['mdMaterialId'] == null ? undefined : json['mdMaterialId'],
        'mdCompanyNo': json['mdCompanyNo'] == null ? undefined : json['mdCompanyNo'],
        'ciCompanyName': json['ciCompanyName'] == null ? undefined : json['ciCompanyName'],
        'mdSeries': json['mdSeries'] == null ? undefined : json['mdSeries'],
        'psProductSeriesName': json['psProductSeriesName'] == null ? undefined : json['psProductSeriesName'],
        'psWebSeriesName': json['psWebSeriesName'] == null ? undefined : json['psWebSeriesName'],
        'mdProduct': json['mdProduct'] == null ? undefined : json['mdProduct'],
        'mdCostPrice': json['mdCostPrice'] == null ? undefined : json['mdCostPrice'],
        'mdCurrency': json['mdCurrency'] == null ? undefined : json['mdCurrency'],
        'mdDeposit': json['mdDeposit'] == null ? undefined : json['mdDeposit'],
        'mdLiveDateS': json['mdLiveDateS'] == null ? undefined : json['mdLiveDateS'],
        'mdLiveDateE': json['mdLiveDateE'] == null ? undefined : json['mdLiveDateE'],
        'mdSampLiveDateS': json['mdSampLiveDateS'] == null ? undefined : json['mdSampLiveDateS'],
        'mdSampLiveDateE': json['mdSampLiveDateE'] == null ? undefined : json['mdSampLiveDateE'],
        'mdRfid': json['mdRfid'] == null ? undefined : json['mdRfid'],
        'mdUseStatus': json['mdUseStatus'] == null ? undefined : json['mdUseStatus'],
        'mdDisabledDate': json['mdDisabledDate'] == null ? undefined : json['mdDisabledDate'],
        'mdProductDescription': json['mdProductDescription'] == null ? undefined : json['mdProductDescription'],
        'mdOther': json['mdOther'] == null ? undefined : json['mdOther'],
        'mdSalesAmount': json['mdSalesAmount'] == null ? undefined : json['mdSalesAmount'],
        'mdSalesDate': json['mdSalesDate'] == null ? undefined : json['mdSalesDate'],
        'mdApidate': json['mdApidate'] == null ? undefined : json['mdApidate'],
        'mdApitype': json['mdApitype'] == null ? undefined : json['mdApitype'],
    };
}
function MaterialDataEditViewModelToJSON(json) {
    return MaterialDataEditViewModelToJSONTyped(json, false);
}
function MaterialDataEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'mdMaterialNo': value['mdMaterialNo'],
        'mdOrgId': value['mdOrgId'],
        'oName': value['oName'],
        'mdBackstageKey': value['mdBackstageKey'],
        'mdMaterialId': value['mdMaterialId'],
        'mdCompanyNo': value['mdCompanyNo'],
        'ciCompanyName': value['ciCompanyName'],
        'mdSeries': value['mdSeries'],
        'psProductSeriesName': value['psProductSeriesName'],
        'psWebSeriesName': value['psWebSeriesName'],
        'mdProduct': value['mdProduct'],
        'mdCostPrice': value['mdCostPrice'],
        'mdCurrency': value['mdCurrency'],
        'mdDeposit': value['mdDeposit'],
        'mdLiveDateS': value['mdLiveDateS'],
        'mdLiveDateE': value['mdLiveDateE'],
        'mdSampLiveDateS': value['mdSampLiveDateS'],
        'mdSampLiveDateE': value['mdSampLiveDateE'],
        'mdRfid': value['mdRfid'],
        'mdUseStatus': value['mdUseStatus'],
        'mdDisabledDate': value['mdDisabledDate'],
        'mdProductDescription': value['mdProductDescription'],
        'mdOther': value['mdOther'],
        'mdSalesAmount': value['mdSalesAmount'],
        'mdSalesDate': value['mdSalesDate'],
        'mdApidate': value['mdApidate'],
        'mdApitype': value['mdApitype'],
    };
}
